import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { BafAgentService } from '../../core/services/baf-agent/baf-agent.service';
import { Observable } from 'rxjs/Observable';
import { NotificationService } from '../notification/notification.service';

@Injectable()
export class UserProfileService implements OnDestroy {
  private isAlive = true;
  private profile = new Subject<any>();

  constructor(private bafAgent: BafAgentService, private notifier: NotificationService) {
    bafAgent
      .loadUserProfile()
      .takeWhile(() => this.isAlive)
      .subscribe(profile => {
        this.profile.next(profile);
      });
  }

  get profileStream(): Observable<any> {
    return this.profile.asObservable();
  }

  loadValue(key: string): Observable<string> {
    return this.bafAgent.loadUserValue(key);
  }

  saveValue(key: string, value: string): Observable<any> {
    return this.bafAgent.saveUserValue(key, value);
  }

  clear() {
    this.bafAgent
      .clearUser()
      .subscribe(() => this.notifier.success('Profil użytkownika został wyczyszczony'));
  }

  ngOnDestroy() {
    this.isAlive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user-profile/user-profile.service.ts